import $ from 'jquery';

const defaults = {
  trim: false,
};

function Placeholder(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.trim = this.settings.trim;
  this.init();
}

Placeholder.prototype = {
  init() {
    let label = this.$element.find('label').text();
    if (label.length) {
      if (this.trim) {
        label = label.substring(0, label.indexOf(':'));
        this.$element.find('label').text(label);
      }
      this.$element.find('input').attr('placeholder', label.trim());
    }
  },
};

export default Placeholder;
